import { Inject, Injectable } from '@angular/core';
import { FactItem, PMA_GATEWAY } from './pma-gateway.interface';
import { PmaGateway } from './pma-gateway.interface';
import { catchError, map, of, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PmaController {
  constructor(@Inject(PMA_GATEWAY) private readonly pmaGateway: PmaGateway) {}

  facts$ = this.pmaGateway.getFacts().pipe(
    map((response) => response.items),
    catchError(() => of([] as FactItem[])),
    shareReplay({ bufferSize: 1, refCount: true }),
  );
}
